/* ==========================================================================
# Scrollbar Carousel
========================================================================== */

function updateCardWidth(carouselWrapper) {
  const carouselContainers = carouselWrapper.querySelectorAll('.js-scrollbar-carousel');

  carouselContainers.forEach(carouselContainer => {
    const carouselCards = carouselContainer.querySelectorAll('.js-scrollbar-carousel-card');

    if (carouselCards.length > 0) {
      const containerStyles = getComputedStyle(carouselWrapper);
      const containerWidth = carouselWrapper.offsetWidth - parseFloat(containerStyles.paddingLeft) - parseFloat(containerStyles.paddingRight);

      const dataDesktopSlides = parseInt(carouselContainer.getAttribute('data-desktop-slides'));
      const dataMobileSlides = parseInt(carouselContainer.getAttribute('data-mobile-slides'));

      let cardWidth;
      let maxVisibleCards;

      if (window.innerWidth < 768) {
        cardWidth = containerWidth / dataMobileSlides - 15;
        maxVisibleCards = dataMobileSlides + 1;
      } else {
        cardWidth = containerWidth / dataDesktopSlides - 15;
        maxVisibleCards = dataDesktopSlides + 1;
      }

      carouselCards.forEach(card => {
        card.style.minWidth = `${cardWidth}px`;
      });

      if (carouselCards.length < maxVisibleCards) {
        carouselContainer.classList.remove('overflow-x-scroll');
        carouselCards.forEach(card => {
          card.classList.remove('mb-8');
        });
      } else {
        carouselContainer.classList.add('overflow-x-scroll');
      }
    }
  });

  // Determine if the active carousel should hide the scrollbar
  const activeCarousel = carouselWrapper.querySelector('.active-carousel');
  if (activeCarousel) {
    const activeCarouselCards = activeCarousel.querySelectorAll('.js-scrollbar-carousel-card');

    const dataDesktopSlides = parseInt(activeCarousel.getAttribute('data-desktop-slides'));
    const dataMobileSlides = parseInt(activeCarousel.getAttribute('data-mobile-slides'));

    const activeCarouselMaxVisibleCards = window.innerWidth < 768 ? dataMobileSlides + 1 : dataDesktopSlides + 1;

    const scrollbar = carouselWrapper.querySelector('.js-scrollbar');
    if (activeCarouselCards.length < activeCarouselMaxVisibleCards) {
      scrollbar.style.display = 'none';
    } else {
      scrollbar.style.display = 'block';
    }
  }
}

function initializeCarousels() {
  const carouselWrappers = document.querySelectorAll('.js-scrollbar-carousel-wrapper');
  
  carouselWrappers.forEach(carouselWrapper => {
    updateCardWidth(carouselWrapper);
    setInterval(() => updateCardWidth(carouselWrapper), 100); // Regularly check and update
  });
}

// Call the function on page load and window resize for each wrapper
window.addEventListener('load', initializeCarousels);
window.addEventListener('resize', initializeCarousels);

document.addEventListener('DOMContentLoaded', () => {
  const scrollbarWrappers = document.querySelectorAll('.js-scrollbar-carousel-wrapper');

  scrollbarWrappers.forEach(scrollbarWrapper => {
    const thumb = scrollbarWrapper.querySelector('.js-scrollbar-thumb');
    const carousels = scrollbarWrapper.querySelectorAll('.js-scrollbar-carousel');
    let activeCarousel = scrollbarWrapper.querySelector('.active-carousel');
    let isDragging = false;
    let startX = 0;
    let scrollX = 0;

    function updateThumbPosition() {
      const scrollPercentage = (activeCarousel.scrollLeft / (activeCarousel.scrollWidth - activeCarousel.clientWidth)) * 100;
      const thumbPosition = (activeCarousel.clientWidth - thumb.clientWidth) * (scrollPercentage / 100);
      thumb.style.left = `${thumbPosition}px`;
    }

    function handleDragStart(event) {
      event.preventDefault();
      isDragging = true;

      if (event.type === 'touchstart') {
        startX = event.touches[0].clientX;
        scrollX = activeCarousel.scrollLeft;

        document.addEventListener('touchmove', handleDragMove);
        document.addEventListener('touchend', handleDragEnd);
      } else if (event.type === 'mousedown') {
        startX = event.clientX;
        scrollX = activeCarousel.scrollLeft;

        document.addEventListener('mousemove', handleDragMove);
        document.addEventListener('mouseup', handleDragEnd);
      }
    }

    function handleDragMove(event) {
      if (!isDragging) return;
      const clientX = event.type === 'touchmove' ? event.touches[0].clientX : event.clientX;
      const deltaX = clientX - startX;
      const newScrollX = scrollX + deltaX;
      const maxScrollX = activeCarousel.scrollWidth - activeCarousel.clientWidth;
      const scrollPercentage = (newScrollX / maxScrollX) * 100;
      activeCarousel.scrollLeft = (scrollPercentage / 100) * maxScrollX;
    }

    function handleDragEnd(event) {
      isDragging = false;

      document.removeEventListener('mousemove', handleDragMove);
      document.removeEventListener('mouseup', handleDragEnd);
      document.removeEventListener('touchmove', handleDragMove);
      document.removeEventListener('touchend', handleDragEnd);
    }

    thumb.addEventListener('mousedown', handleDragStart);
    thumb.addEventListener('touchstart', handleDragStart);

    function updateActiveCarousel() {
      activeCarousel = scrollbarWrapper.querySelector('.active-carousel');
      updateThumbPosition();
    }

    // Update active carousel periodically
    setInterval(updateActiveCarousel, 100);

    // Initial thumb position update
    updateThumbPosition();
  });

});

function sliderDrag() {
  var sliders = document.querySelectorAll(".js-scrollbar-carousel.active-carousel");

  sliders.forEach(function (slider) {
    var isDown = false;
    var startX;
    var scrollLeft;

    const slideCards = slider.querySelectorAll(".js-scrollbar-carousel-card");

    slider.addEventListener("mousedown", function (e) {
      isDown = true;
      slider.classList.add("cursor-grabbing");
      slider.classList.remove("cursor-grab");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", function () {
      isDown = false;
      slider.classList.remove("cursor-grabbing");
      slider.classList.add("cursor-grab");

      slideCards.forEach(function (slideCard) {
        slideCard.classList.remove("pointer-events-none");
      });

    });

    slider.addEventListener("mouseup", function () {
      isDown = false;
      slider.classList.remove("cursor-grabbing");
      slider.classList.add("cursor-grab");

      slideCards.forEach(function (slideCard) {
        slideCard.classList.remove("pointer-events-none");
      });

    });

    slider.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      e.preventDefault();

      slideCards.forEach(function (slideCard) {
        slideCard.classList.add("pointer-events-none");
      });
      
      var x = e.pageX - slider.offsetLeft;
      var walk = (x - startX) * 3; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    });
    
  });
}

setInterval(sliderDrag, 100);